import { useCallback } from 'react';
import { PageContainer } from '@ant-design/pro-components';
import { useOrganizationPath } from '@/common/hooks/use-organization-path';
import { useQueryParams } from '@/common/hooks/use-query-params';
import OperationEntityManagement from '../components/OperationEntityManagement';
import StoreTable from '../components/StoreTable';

const STORE_TAB = 'stores';
const OPERATION_ENTITIES_TAB = 'operation-entities';

const Stores = () => {
  const { organizationId } = useOrganizationPath();
  const [query, setQuery] = useQueryParams();
  const activeTab = query.tab === OPERATION_ENTITIES_TAB ? OPERATION_ENTITIES_TAB : STORE_TAB;

  const handleTabChange = useCallback(
    (tab) => {
      setQuery({ tab: tab === STORE_TAB ? undefined : tab }, { replace: true });
    },
    [setQuery],
  );

  return (
    <PageContainer
      content="管理员维护门店主数据与组织结构。"
      tabActiveKey={activeTab}
      tabList={[
        { key: STORE_TAB, tab: '门店数据' },
        { key: OPERATION_ENTITIES_TAB, tab: '组织结构' },
      ]}
      onTabChange={handleTabChange}
    >
      {activeTab === STORE_TAB ? <StoreTable organizationId={organizationId} /> : null}
      {activeTab === OPERATION_ENTITIES_TAB ? <OperationEntityManagement /> : null}
    </PageContainer>
  );
};

export default Stores;
